import { getCartskuByid } from '@/common/miscutil'
import {
  PERM_ORDER_AUDIT_OPERATE,
  PERM_ORDER_SIGNIN_OPERATE,
  PERM_ORDER_SCOPE_COMPANY,
  PERM_STAFF_OPERATE,
  PERM_SHOP_OPERATE,
  PERM_BUYER_OPERATE,
  PERM_SKUGROUP_OPERATE,
  PERM_COMPANY_CONFIG_OPERATE,
  PERM_CUSTOM_SCOPE_COMPANY,
  PERM_SKU_OPERATE,
  PERM_STORE_BILL_VIEW,
  PERM_BUYER_ORDER_OPERATE,
  PERM_BUYER_CUSTOM_OPERATE,
  PERM_SELLER_CUSTOM_OPERATE,
  PERM_LOGISTICS_CUSTOM_OPERATE,
  PERM_HR_COMMISSIONS_VIEW,
  PERM_HR_COMMISSIONS_SCOPE_COMPANY,
  PERM_HR_COMMISSIONS_OPERATE,
  PERM_COMPANY_REPORT_VIEW,
  PERM_SALEUSER_STAT_VIEW,
  PERM_BUYER_ORDER_AUDIT_OPERATE,
  PERM_ORDER_OPERATE
} from 'rpc/MisComm/MisComm'
import floatutil from 'jscom/utils/floatutil'

function _hasPerm (state, perm) {
  let userInfoEx = state.userInfo
  if (!userInfoEx.isValid()) {
    return false
  }
  let permissions = userInfoEx.data.permissions
  return (permissions.indexOf(perm) !== -1)
}

function _cartList (state) {
  if (state.appType === 'seller' && state.operationStatus.custom) {
    let customid = state.operationStatus.custom.customid
    let sellerCart = state.sellerCartMap[customid]
    if (!sellerCart) {
      return []
    }
    return sellerCart
  } else {
    return state.cartList
  }
}
export default {
  isLogin: function (state) {
    if (state.userOauth && state.userOauth.access_token) {
      return true
    }
    return false
  },
  userInfo: function (state) {
    let userInfoEx = state.userInfo
    if (!userInfoEx.isValid()) {
      return null
    }
    return userInfoEx.data
  },
  hasAuditPerm: function (state) {
    let userInfoEx = state.userInfo
    if (!userInfoEx.isValid()) {
      return false
    }
    let permissions = userInfoEx.data.permissions
    return (permissions.indexOf(PERM_ORDER_AUDIT_OPERATE) !== -1)
  },
  hasSigninPerm: function (state) {
    let userInfoEx = state.userInfo
    if (!userInfoEx.isValid()) {
      return false
    }
    let permissions = userInfoEx.data.permissions
    return (permissions.indexOf(PERM_ORDER_SIGNIN_OPERATE) !== -1)
  },
  hasCompanyScope: function (state) {
    let userInfoEx = state.userInfo
    if (!userInfoEx.isValid()) {
      return false
    }
    let permissions = userInfoEx.data.permissions
    return (permissions.indexOf(PERM_ORDER_SCOPE_COMPANY) !== -1)
  },
  hasStaffManagePerm: function (state) {
    return _hasPerm(state, PERM_STAFF_OPERATE)
  },
  hasShopManagePerm: function (state) {
    return _hasPerm(state, PERM_SHOP_OPERATE)
  },
  hasBuyerCustomManagePerm: function (state) {
    return _hasPerm(state, PERM_BUYER_CUSTOM_OPERATE)
  },
  hasSellerCustomManagePerm: function (state) {
    return _hasPerm(state, PERM_SELLER_CUSTOM_OPERATE)
  },
  hasLogisticsCustomManagePerm: function (state) {
    return _hasPerm(state, PERM_LOGISTICS_CUSTOM_OPERATE)
  },
  hasBuyerManagePerm: function (state) {
    return _hasPerm(state, PERM_BUYER_OPERATE)
  },
  hasSkuGroupManagePerm: function (state) {
    return _hasPerm(state, PERM_SKUGROUP_OPERATE)
  },
  hasUpdateNotifyUseridsPerm: function (state) {
    return _hasPerm(state, PERM_COMPANY_CONFIG_OPERATE)
  },
  hasScopeCompanyPerm: function (state) {
    return _hasPerm(state, PERM_CUSTOM_SCOPE_COMPANY)
  },
  hasSkuEditPerm: function (state) {
    return _hasPerm(state, PERM_SKU_OPERATE)
  },
  hasStoreBillView: function (state) {
    return _hasPerm(state, PERM_STORE_BILL_VIEW)
  },
  hasBuyerOrderOperatePerm: function (state) {
    return _hasPerm(state, PERM_BUYER_ORDER_OPERATE)
  },
  hasBuyerOrderAuditPerm: function (state) {
    return _hasPerm(state, PERM_BUYER_ORDER_AUDIT_OPERATE)
  },
  hasHrCommissionsPerm: function (state) {
    return _hasPerm(state, PERM_HR_COMMISSIONS_VIEW)
  },
  hasHrCommissionsScopePerm: function (state) {
    return _hasPerm(state, PERM_HR_COMMISSIONS_SCOPE_COMPANY)
  },
  hsaHrCommissionsOperatePerm: function (state) {
    return _hasPerm(state, PERM_HR_COMMISSIONS_OPERATE)
  },
  hsaCompanyReportPerm: function (state) {
    return _hasPerm(state, PERM_COMPANY_REPORT_VIEW)
  },
  hsaSaleuserStatPerm: function (state) {
    return _hasPerm(state, PERM_SALEUSER_STAT_VIEW)
  },
  hsaOrderOperate: function (state) {
    return _hasPerm(state, PERM_ORDER_OPERATE)
  },
  isSellerApp: function (state) {
    return state.appType === 'seller'
  },
  isSeller: function (state) {
    let userInfoEx = state.userInfo
    return (userInfoEx.isValid() && (userInfoEx.data.role === 'sellManager' ||
        userInfoEx.data.role === 'sellOperator'))
  },
  isBuyer: function (state) {
    let userInfoEx = state.userInfo
    return (userInfoEx.isValid() && (userInfoEx.data.role === 'buyManager' ||
        userInfoEx.data.role === 'buyOperator'))
  },
  isBuyManager: function (state) {
    let userInfoEx = state.userInfo
    return (userInfoEx.isValid() && userInfoEx.data.role === 'buyManager')
  },
  isDeliveryMan: function (state) {
    let userInfoEx = state.userInfo
    return (userInfoEx.isValid() && userInfoEx.data.role === 'deliveryOperator')
  },
  appid: function (state) {
    return state.config.appid || ''
  },
  vipCardId: function (state) {
    return state.config.vip_cardid || ''
  },
  version: function (state) {
    return state.config.version || ''
  },
  companyCardId: function (state) {
    return state.config.company_cardid || ''
  },
  platformCompanyCardId: function (state) {
    return state.config.platform_company_cardid || ''
  },
  platformUserCardId: function (state) {
    return state.config.platform_user_cardid || ''
  },
  buyerCompanyid: function (state) {
    let userInfoEx = state.userInfo
    if (userInfoEx.isValid()) {
      return userInfoEx.data.companyid
    }
    return 0
  },
  sellerCompanyid: function () {
    return 1
  },
  buyerShopid: function (state) {
    return state.buyerShopid
  },
  sellerCustomid: function (state) {
    return state.sellerCustomid
  },
  operationStatus: function (state) {
    return function (opKey, defaultValue) {
      return (state.operationStatus[opKey] || defaultValue)
    }
  },
  totalCartItem: function (state) {
    let totalCount = null
    let cartList = _cartList(state)
    for (let cartSku of cartList) {
      if (!cartSku.valid || !cartSku.count) {
        continue
      }
      totalCount = floatutil.add(cartSku.count, totalCount)
    }
    return totalCount
  },
  totalCartPrice: function (state) {
    let totalPrice = 0
    let cartList = _cartList(state)
    for (let cartSku of cartList) {
      if (!cartSku.valid || !cartSku.count || !cartSku.ss_price) {
        continue
      }
      totalPrice = floatutil.add(totalPrice, floatutil.multiply_prec(cartSku.count, cartSku.ss_price))
    }
    return totalPrice
  },
  cartSkuCount: function (state) {
    return function (skuid) {
      let cartList = _cartList(state)
      let count = 0
      let cartSku = getCartskuByid(cartList, skuid)
      if (cartSku) {
        count = cartSku.count
      }
      return count
    }
  },
  cartSku: function (state) {
    return function (skuid) {
      let cartList = _cartList(state)
      return getCartskuByid(cartList, skuid)
    }
  },
  lastPaymethod: function (state) {
    return function (contractid, defaultValue) {
      return (state.lastPaymethods[contractid] || defaultValue)
    }
  },
  supplierCount: function (state) {
    return function (customids) {
      let count = 0
      for (let customid of customids) {
        let supplierItem = state.supplierSkuMap[customid]
        for (let skuid in supplierItem) {
          if (supplierItem[skuid].checked && supplierItem[skuid].count > 0) {
            count += 1
            break
          }
        }
      }
      return count
    }
  },
  supplierSkuCount: function (state) {
    return function (customid) {
      let count = 0
      let skuMap = state.supplierSkuMap[customid]
      if (skuMap) {
        for (let skuid in skuMap) {
          if (skuMap[skuid].checked) {
            count = floatutil.add(count, skuMap[skuid].count)
          }
        }
      }
      return count
    }
  },
  totalSkuCount: function (state) {
    return function (customids) {
      let count = 0
      for (let customid of customids) {
        let supplierItem = state.supplierSkuMap[customid]
        for (let skuid in supplierItem) {
          if (supplierItem[skuid].checked) {
            count = floatutil.add(count, supplierItem[skuid].count)
          }
        }
      }
      return count
    }
  },
  skuCount: function (state) {
    return function (customid, skuid) {
      let supplierItem = state.supplierSkuMap[customid]
      if (!supplierItem) {
        return 0
      }
      let skuItem = supplierItem[skuid]
      if (!skuItem) {
        return 0
      }
      return skuItem.count
    }
  },
  skuChecked: function (state) {
    return function (customid, skuid) {
      let supplierItem = state.supplierSkuMap[customid]
      if (!supplierItem) {
        return false
      }
      let skuItem = supplierItem[skuid]
      if (!skuItem) {
        return false
      }
      return skuItem.checked
    }
  },
  mallTotalPrice: function (state) {
    return function (customids) {
      let totalPrice = 0
      for (let customid of customids) {
        let supplierItem = state.supplierSkuMap[customid]
        for (let skuid in supplierItem) {
          if (supplierItem[skuid].checked) {
            totalPrice = floatutil.add(totalPrice, floatutil.multiply_prec(supplierItem[skuid].count, supplierItem[skuid].ss_price))
          }
        }
      }
      return totalPrice
    }
  },
  cartList: function (state) {
    return _cartList(state)
  },
  companyFormInfo (state) {
    return state.companyFormInfo
  }
}



// WEBPACK FOOTER //
// ./src/apps/baseapp/store/getters.js